export default FACE_PATHS
